import React from "react";
import { SEO } from "../components/SEO";

export const Privacidade = () => {
  return (
    <div className="bg-slate-50 min-h-screen py-20">
      <SEO 
        title="Política de Privacidade - RosTech" 
        description="Política de Privacidade do sistema RosTech."
        canonicalUrl="/privacidade"
      />
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-slate-100">
          <h1 className="text-4xl font-extrabold text-slate-900 mb-8">Política de Privacidade</h1>
          
          <div className="prose prose-slate max-w-none prose-h2:text-2xl prose-h2:font-bold prose-h2:mt-8 prose-h2:mb-4 prose-p:text-slate-600 prose-p:leading-relaxed">
            <p className="text-lg text-slate-500 mb-8">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

            <h2>1. Informações que Coletamos</h2>
            <p>
              Ao utilizar o RosTech, podemos coletar os seguintes tipos de informações:
              <br /><br />
              <strong>Informações de Cadastro:</strong> Nome, e-mail, telefone, CPF/CNPJ e dados da sua oficina necessários para a prestação do serviço.
              <br />
              <strong>Dados de Uso:</strong> Informações sobre como você interage com nossa plataforma, recursos mais acessados e métricas de desempenho.
              <br />
              <strong>Dados Financeiros:</strong> Quando efetuadas assinaturas ou operações via sistema (PDV), processamos as informações em conformidade com as legislações de proteção a dados.
            </p>

            <h2>2. Como Usamos suas Informações</h2>
            <p>
              Utilizamos suas informações para:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-6">
              <li className="mb-2">Fornecer, operar e manter nossos serviços;</li>
              <li className="mb-2">Melhorar, personalizar e expandir nossa plataforma;</li>
              <li className="mb-2">Entender e analisar como você usa nosso sistema;</li>
              <li className="mb-2">Desenvolver novos produtos, serviços e funcionalidades;</li>
              <li className="mb-2">Comunicar com você para suporte e atualizações;</li>
              <li className="mb-2">Prevenir fraudes e manter a segurança de nossos usuários.</li>
            </ul>

            <h2>3. Compartilhamento de Dados</h2>
            <p>
              Não vendemos suas informações pessoais. Podemos compartilhar seus dados em situações limitadas, como com fornecedores terceirizados que operam serviços essenciais ao nosso funcionamento (ex: provedores de nuvem e gateways de pagamento), sob rigorosos acordos de confidencialidade.
            </p>

            <h2>4. Segurança dos Dados</h2>
            <p>
              A segurança de seus dados é prioridade para a RosTech. Adotamos medidas técnicas, administrativas e físicas projetadas para proteger suas informações contra acessos não autorizados, perdas ou alterações. Contudo, nenhuma plataforma na internet é 100% segura; portanto, apesar de nossos esforços, não podemos garantir sua total segurança.
            </p>

            <h2>5. Seus Direitos de Privacidade</h2>
            <p>
              Você tem o direito de solicitar o acesso, correção ou exclusão de seus dados pessoais. Se desejar exercer algum destes direitos estabelecidos pela legislação aplicável, como a LGPD, entre em contato conosco através de nossos canais de atendimento.
            </p>

            <h2>6. Mudanças nesta Política</h2>
            <p>
              Podemos atualizar nossa Política de Privacidade periodicamente. Avisaremos você sobre quaisquer mudanças relevantes, publicando a nova política nesta página. Recomendamos revisar esta página regularmente para estar sempre informado sobre como protegemos suas informações.
            </p>

            <h2>7. Contato</h2>
            <p>
              Se você tiver qualquer dúvida ou solicitação relacionada aos seus dados, entre em contato conosco:
              <br />
              <strong>Telefone / WhatsApp:</strong> (24) 9.9281-8632
              <br />
              <strong>E-mail:</strong> devckout@gmail.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
